'use client'

import { createContext, useContext, useState, ReactNode } from 'react'

interface ActivityRefreshContextType {
  refreshTrigger: number
  triggerRefresh: () => void
}

const ActivityRefreshContext = createContext<ActivityRefreshContextType | undefined>(undefined)

/**
 * Super simple context provider to trigger a refresh of the dashboard when
 * the user cancels an activity, edits an activity, etc.
 *
 * FIXME: This is a super simple and temporary solution to make the app more responsive.
 * We should find a better solution to handle this once we have some kind of app state management.
 */
function ActivityRefreshProvider({ children }: { children: ReactNode }) {
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  const triggerRefresh = () => {
    setRefreshTrigger((prev) => prev + 1)
  }

  return (
    <ActivityRefreshContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </ActivityRefreshContext.Provider>
  )
}

function useActivityRefresh() {
  const context = useContext(ActivityRefreshContext)
  if (context === undefined) {
    throw new Error('useActivityRefresh must be used within an ActivityRefreshProvider')
  }
  return context
}

export { ActivityRefreshProvider as BaseActivityRefreshProvider, useActivityRefresh }
